module.exports = __webpack_public_path__ + "img/qrcode.fe3e6382.jpg";